"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Categories = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
const react_1 = require("react");
const uuid_1 = require("uuid");
const de_ui_1 = require("@delab-team/de-ui");
const react_i18next_1 = require("react-i18next");
const app_card_1 = require("../../../components/app-card");
const app_card_skeleton_1 = require("../../../components/app-card/app-card-skeleton");
const categories_module_css_1 = __importDefault(require("./categories.module.css"));
const Categories = ({ isTg, selectedLanguage, data, isLoading }) => {
    // const [ data, setData ] = useState<AppItemType[] | undefined>(undefined)
    // const [ isLoading, setIsLoading ] = useState<boolean>(false)
    const { t } = (0, react_i18next_1.useTranslation)();
    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             setIsLoading(true)
    //             const api = new DataApi()
    //             const items = await api.getItems(selectedLanguage)
    //             setData(items)
    //         } catch (error) {
    //             console.error('Error when including data:', error)
    //         } finally {
    //             setTimeout(() => {
    //                 setIsLoading(false)
    //             }, 300)
    //         }
    //     }
    //     fetchData()
    // }, [ selectedLanguage ])
    const groupedItems = {};
    data?.forEach((item) => {
        if (item.categories) {
            item.categories.forEach((category) => {
                if (!groupedItems[category]) {
                    groupedItems[category] = [];
                }
                groupedItems[category].push(item);
            });
        }
    });
    return ((0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: categories_module_css_1.default.inner, children: [groupedItems.DeLab && ((0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: categories_module_css_1.default.allApps, children: [(0, jsx_runtime_1.jsx)("div", { className: categories_module_css_1.default.allAppsTop, children: (0, jsx_runtime_1.jsx)(de_ui_1.Title, { variant: "h3", className: categories_module_css_1.default.allAppsTitle, children: t('common.from-delab') }) }), (0, jsx_runtime_1.jsx)("div", { className: categories_module_css_1.default.allAppsItems, children: isLoading
                            ? Array(6)
                                .fill(null)
                                .map(_ => (0, jsx_runtime_1.jsx)(app_card_skeleton_1.AppCardSkeleton, {}, (0, uuid_1.v1)()))
                            : (groupedItems.DeLab || []).map(el => ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: (0, jsx_runtime_1.jsx)(app_card_1.AppCard, { isTg: isTg, ...el }, (0, uuid_1.v1)()) }, (0, uuid_1.v1)()))) })] }, "DeLab")), Object.keys(groupedItems)
                .filter(category => category !== 'DeLab')
                .map(category => ((0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: categories_module_css_1.default.allApps, children: [(0, jsx_runtime_1.jsx)("div", { className: categories_module_css_1.default.allAppsTop, children: (0, jsx_runtime_1.jsx)(de_ui_1.Title, { variant: "h3", className: categories_module_css_1.default.allAppsTitle, children: category }) }), (0, jsx_runtime_1.jsx)("div", { className: categories_module_css_1.default.allAppsItems, children: isLoading
                            ? Array(6)
                                .fill(null)
                                .map((_, index) => (0, jsx_runtime_1.jsx)(app_card_skeleton_1.AppCardSkeleton, {}, index))
                            : groupedItems[category].map(el => ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: (0, jsx_runtime_1.jsx)(app_card_1.AppCard, { isTg: isTg, ...el }, (0, uuid_1.v1)()) }, (0, uuid_1.v1)()))) })] }, category)))] }));
};
exports.Categories = Categories;
